// 服务类型（包含顾问和缴费）
const PAYMENT_CATEGORY = {
  SIMPLIFIED: '1', // '簡易復效'
  G03: '2', // G03
  RENEW: '3', // '繳交續期保費'
  APERIODIC: '4', // '非定期保费'
  MODIFY: '5', // '保单更改保费'
  FIRST_PREMIUM: '6', // '缴交首期保费'
  WITHDRAW: '7', // 即磅（提现）
  CHANGE_AUTOPAY_DATE: '8', // 更改自动转账日期
  CHANGE_CONTACT: '9', // 更改联系方式
  CHANGE_ASSRESS: '10', // 更改通讯地址
  CHANGE_PAYMENT_INFO: '13', // 更改通讯地址
  SKIP_RESUME_PAYMENT: '14', // 更改通讯地址
  CHANGE_OWNERSHIP: '15', // 更改保單持有人
  SURVIVAL_PROOF: '16', // 提交在生證明
  EBANKIN_ACCOUNT_SETUP: '17' // 設立電子入賬戶口
}

// 支付方法
const PAYMENT_METHOD = {
  FPS: 'F', // FPS转数快
  CREDIT_CARD: 'C', // 信用卡
  OFFLINE: 'O', // 线下支付
  CHEQUE: 'H' // 支票
}

export default PAYMENT_CATEGORY

export {
  PAYMENT_CATEGORY,
  PAYMENT_METHOD
}
